/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.getConvoForMembers'

export { $nsid }

const main = l.query(
  $nsid,
  l.params({
    members: l.array(l.string({ format: 'did' }), {
      minLength: 1,
      maxLength: 10,
    }),
  }),
  l.jsonPayload({
    convo: l.ref<ConvoDefs.ConvoView>((() => ConvoDefs.convoView) as any),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
